import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/permisosDeAcceso/holidays";
import holidaysPermission from '../../models/permisosDeAcceso/typesHolidays'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    holidays: [],
    new:[],
    edit: [],
    deleteItem: [],
    showAdd:false,
    permissionId:null,
    holidaysId: [],
    openHolidays: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setHolidays(state, data) {
      state.holidays = data;
    },
    setHolidaysId(state, data) {
      state.holidaysId = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data ;
    },
    setShowAdd(state, data) {
      state.showAdd = data ;
    },

    setNew(state,data){
      state.new = data;
    },
    setPermissionId(state,data){
      state.permissionId = data;
    },
    setOpenHolidays(state, data) {
      state.openHolidays = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    }
  },
  actions: {
    async getHolidays(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getHolidays();

          state.commit("setHolidays",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getHolidaysId(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getHolidayPermission(state.state.permissionId);

          state.commit("setHolidaysId",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

      async new(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.new(state.state.new).then(() => {
              let item = state.state.new;
              let options = state.state.holidaysId;
      
              let newItems = [];
              item.holidays.forEach((id, index) => {
                newItems.push(holidaysPermission.fromJson({
                  tipoFerId: id,
                  tipoFerNombre: item.holidaysName[index],
                }));
              });
           
              options.push(...newItems); 
              state.commit('setHolidaysId', options);
              resolve(true);
            });
          } catch (error) {
            reject(error);
          }
        });
      },
      
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
       await state.state.service.delete(state.state.deleteItem).then(() => {
       
        let options = state.state.holidaysId
        const deleteItem = state.state.deleteItem
        
        options = options.filter(option => {
          return option.id != deleteItem.id
        })
          state.commit('setHolidaysId', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)
  
        }
      })
     
    },
  },
});
